import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { SharedService } from '../../../shared/shared.service';
import { LoaderService } from '../../../core/services/loader.service';
import { Roles } from '../../../shared/constants/enum';
import { NotificationService } from '../../../shared/notification.service';
import { ConsumersService } from '../../../core/services/consumers.service';

@Component({
  selector: 'app-rp-consumption-view',
  templateUrl: './rp-consumption-view.component.html',
  styleUrl: './rp-consumption-view.component.scss',
  standalone: false,
})
export class RpConsumptionViewComponent {
  isAllOpen: boolean = true;
  isotherChargesOpen: boolean = true;
  consumption: any;
  consumptionHistoyList: any;
  undefinde: any;
  triSourceBillingMethodology: any;
  breadCrumbItems: Array<{}> | undefined;
  currentUser: any;
  consumptionId: any;
  heading: String = '';
  roles = Roles;
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private loaderService: LoaderService,
    private store: Store,
    private sharedService: SharedService,
    private consumersService: ConsumersService
  ) {
    this.notificationService.emitNotificationUpdate();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') ?? '');
    this.triSourceBillingMethodology =
      this.currentUser?.project?.triSourceBillingMethodology;
    if (
      history.state.consumption != undefined &&
      history.state.consumption !== null
    ) {
      this.consumption = history.state.consumption;
      this.consumptionId = history.state.consumption.id;
      this.isotherChargesOpen =
        this.consumption?.otherCharges?.length > 0 ? true : false;
      this.heading =
        this.consumption?.billType === 'Admin Deduction'
          ? 'Wallet Deductions'
          : 'Payment Information';
    }

    //////////////////
    if (
      this.currentUser?.currentUserRoleDetails?.role == this.roles.ADMIN &&
      !this.consumption?.isWallet
    ) {
      this.breadCrumbItems = [
        { label: 'Meters', url: 'meters', active: true },
        { label: 'Meter Details', url: 'meters/metersView', active: true },
        { label: 'Consumption History' },
      ];
    } else {
      if (
        this.currentUser?.currentUserRoleDetails?.role == this.roles.CONSUMER &&
        this.consumption.isWallet == true
      ) {
        this.breadCrumbItems = [
          {
            label: 'Wallet History',
            url: 'walletHistory',
            active: true,
          },
          { label: 'Consumption History' },
        ];
      } else if (
        this.currentUser?.currentUserRoleDetails?.role == this.roles.ADMIN &&
        this.consumption?.isWallet &&
        this.consumption?.billType !== 'Admin Deduction'
      ) {
        this.breadCrumbItems = [
          { label: 'Wallet', url: 'wallet', active: true },
          {
            label: 'Wallet Details',
            url: 'wallet/walletDetails',
            active: true,
          },
          { label: 'Consumption History' },
        ];
      } else if (
        this.currentUser?.currentUserRoleDetails?.role == this.roles.ADMIN &&
        this.consumption?.isWallet &&
        this.consumption?.billType === 'Admin Deduction'
      ) {
        this.breadCrumbItems = [
          { label: 'Wallet', url: 'wallet', active: true },
          {
            label: 'Wallet Details',
            url: 'wallet/walletDetails',
            active: true,
          },
        ];
      } else {
        this.breadCrumbItems = [
          {
            label: 'Consumption History',
            url: 'consumptionHistory',
            active: true,
          },
          { label: 'Consumption History' },
        ];
      }
    }
  }

  // ngAfterViewInit() {
  ngOnInit() {
    if (!this.consumption?.isWallet) {
      //console.log(this.consumption);
      this.consumersService
        .getConsumptionHistoryById(this.consumptionId)
        .subscribe({
          next: (res) => {
            console.log(res);
            this.consumption = res.data;
            console.log(res);
          },
          error: (err) => {
            console.log(err);
          },
        });
    }
  }
}
